import './base_v3.coffee';
import { init as initFacebookLogin } from '../../components/auth/facebook-login/facebook-login';
import { init as initSignInWithApple } from '../../components/auth/sign-in-with-apple/sign-in-with-apple';
import '../../frontend/react/src/login';

const $login = $('#login-wrapper');

// Apple login
if (window.AppleID) {
  const { APPLE_CLIENT_ID_WEB, APPLE_SCOPE, APPLE_REDIRECT_URI, APPLE_STATE } =
    window as unknown as {
      APPLE_CLIENT_ID_WEB: string;
      APPLE_SCOPE: string;
      APPLE_REDIRECT_URI: string;
      APPLE_STATE: string;
    };

  initSignInWithApple({
    init: {
      clientId: APPLE_CLIENT_ID_WEB,
      scope: APPLE_SCOPE,
      redirectURI: APPLE_REDIRECT_URI,
      state: APPLE_STATE,
    },
    $login,
  });
}

initFacebookLogin({
  $wrapper: $(
    '#login-wrapper, #signup-wrapper, #signup-page, #welcome-pg'
  ).find('.facebook-login'),
  $login,
  $errorContainer: $login.find('.fb-login-error'),
});
